export const subscriptionsSchema = {
	title: 'subscription schema',
	version: 3,
	primaryKey: 'id',
	type: 'object',
	properties: {
		id: {
			type: 'string',
			maxLength: 300,
		},
		status: {
			type: 'string',
		},
		type: {
			type: 'string',
		},
		subscriptionStart: {
			type: 'string',
		},
		pauseStart: {
			type: 'string',
			nullable: true,
		},
		pauseEnd: {
			type: 'string',
			nullable: true,
		},
		canceledAt: {
			type: 'string',
			nullable: true,
		},
		companyName: {
			type: 'string',
		},
		nextCancellationEffectiveDate: {
			type: 'string',
			nullable: true,
		},
		cancellationNoticeDeadline: {
			type: 'string',
			nullable: true,
		},
		disallowCancelCancellation: {
			type: 'boolean',
		},
	},
};
